var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.00004C10.4679 1.99727 8.95562 2.34658 7.57993 3.02101C6.20425 3.69544 5.00192 4.67696 4.06577 5.8898C3.12961 7.10264 2.48466 8.51438 2.18069 10.016C1.87672 11.5177 1.92186 13.0691 2.31263 14.5506C2.7034 16.032 3.42935 17.4038 4.43445 18.5602C5.43954 19.7166 6.6969 20.6265 8.10948 21.2198C9.52205 21.8131 11.0521 22.0739 12.5814 21.982C14.1108 21.8902 15.5986 21.4481 16.93 20.69H17H17.05C18.9753 19.5941 20.4821 17.8898 21.3339 15.8448C22.1858 13.7997 22.3345 11.5297 21.7566 9.39107C21.1788 7.25241 19.9071 5.36618 18.1412 4.02845C16.3753 2.69073 14.2152 1.97727 12 2.00004ZM13 4.07004C14.76 4.29323 16.3959 5.09514 17.6504 6.34963C18.9049 7.60412 19.7068 9.24002 19.93 11H13V4.07004ZM12 20C9.9745 19.9862 8.02965 19.2046 6.55793 17.8129C5.08621 16.4212 4.1972 14.523 4.0703 12.5014C3.94339 10.4799 4.58805 8.48543 5.87417 6.9206C7.1603 5.35577 8.99213 4.33705 11 4.07004V12C11.0039 12.1198 11.0276 12.238 11.07 12.35V12.43V12.5L15.07 19.37C14.0997 19.7853 13.0554 19.9996 12 20ZM16.83 18.36L13.73 13H19.93C19.7954 14.0546 19.4519 15.0718 18.9196 15.9921C18.3873 16.9124 17.6769 17.7174 16.83 18.36Z",
    fill: "#8F99D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPie);
export default __webpack_public_path__ + "static/media/chart_pie.e05a6565.svg";
export { ForwardRef as ReactComponent };